/* eslint-disable import/no-webpack-loader-syntax */
import gendersCsv from '!raw-loader!./genders.csv';
import liftsCsv from '!raw-loader!./lifts.csv';
import bodyweightCategoriesCsv from '!raw-loader!./bodyweightCategories_20250601.csv';
import ageGroupsCsv from '!raw-loader!./ageGroups_20220101.csv';

import { parse } from 'papaparse';
import { find, filter, flatMap, groupBy, map } from 'lodash';

const parseCsv = csvString => {
  const options = {
    header: true,
    skipEmptyLines: true,
  };

  const { data } = parse(csvString, options);

  return data;
};

const markOrder = array => {
  let nextOrder = 1;
  return array.map(props => ({ ...props, order: nextOrder++ }));
};

const parseOrdered = csv => {
  return markOrder(parseCsv(csv));
};

const genders = parseOrdered(gendersCsv);

const parseLift = ({ attemptCount, ...props }) => ({
  ...props,
  attemptCount: Number(attemptCount) || undefined,
});
const parseLifts = csv => markOrder(parseCsv(csv).map(parseLift));

const lifts = parseLifts(liftsCsv);

const parseBodyweightCategory = ({
  genderLetter,
  bodyweightMaximum,
  bodyweightMinimum,
  ...props
}) => ({
  ...props,
  gender: find(genders, { letter: genderLetter }).uuid,
  bodyweightMaximum: Number(bodyweightMaximum) || undefined,
  bodyweightMinimum: Number(bodyweightMinimum) || undefined,
});

const parseBodyweightCatagories = csv =>
  markOrder(
    flatMap(groupBy(parseCsv(csv), 'bundle'), bodyweightCategories =>
      bodyweightCategories.map(parseBodyweightCategory),
    ),
  );

const bodyweightCategories = parseBodyweightCatagories(bodyweightCategoriesCsv);

const parseAgeGroup = ({
  genderLetter,
  ageMinimum,
  ageMaximum,
  bodyweightCategoryBundle,
  ...props
}) => ({
  ...props,
  gender: find(genders, { letter: genderLetter }).uuid,
  ageMinimum: Number(ageMinimum) || undefined,
  ageMaximum: Number(ageMaximum) || undefined,
  bodyweightCategories: map(
    filter(bodyweightCategories, { bundle: bodyweightCategoryBundle }),
    'uuid',
  ),
});

const parseAgeGroups = csv =>
  markOrder(
    flatMap(groupBy(parseCsv(csv), 'bundle'), ageGroups =>
      ageGroups.map(parseAgeGroup),
    ),
  );

const ageGroups = parseAgeGroups(ageGroupsCsv);

const contests = markOrder(
  flatMap(ageGroups, ageGroup =>
    ageGroup.bodyweightCategories.map(bodyweightCategoryUuid => {
      const bodyweightCategory = find(bodyweightCategories, {
        uuid: bodyweightCategoryUuid,
      });
      return {
        ageGroup: ageGroup.uuid,
        bodyweightCategory: bodyweightCategory.uuid,
        order: 0,
        title: `${ageGroup.abbreviation}/${bodyweightCategory.abbreviation}`,
        entryTotalMinimum: undefined,
      };
    }),
  ),
);

export const builtinData = {
  genders,
  lifts,
  bodyweightCategories,
  ageGroups,
  contests,
};



// WEBPACK FOOTER //
// ./src/data/index.js